import axios from 'axios';

export async function readHTML(token, assistantId, input) {
    const url = 'https://chat.int.bayer.com/api/v2/chat/agent';

    const headers = {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
    };

    const msgs = [];

    msgs.push({
        "role": "user",
        "content": input
    });

    const data = {
        messages: msgs,
        assistant_id: assistantId,
    };

    try {
        const response = await axios.post(url, data, { headers });
        console.log('API Response: ', response.data);

        if (!response.data.choices || response.data.choices.length === 0) {
            throw new Error('Incorrect response from API');
        }

        const chatOutputMsg = response.data.choices[0].message.content;
        console.log("Chat Output Message: ", chatOutputMsg);

        const cleanedString = chatOutputMsg.replace(/```json/, '').replace(/```/, '').trim();
        const jsonArray = JSON.parse(cleanedString);

        const newsFormat = (data) => {
            return data.map(item => (
                `<div style="margin-bottom: 20px;">
                    <h4 style="white-space: normal; word-wrap: break-word;">${item.TituloNoticia}</h4>
                    <p><strong>Data de Publicação:</strong> ${item.DataPublicacao}</p>
                    <p><a href="${item.LinkNoticia}" target="_blank">Leia mais</a></p>
                </div>`
            )).join('');
        };
        const newsOutput = newsFormat(jsonArray);

        return newsOutput;
    } catch (error) {
        console.error('Error in readHTML: ', error);
        throw error;
    }
}
